
import linkagecell from "./linkagecell.vue";
import layer1 from "@/data/layer1_new.json";
import layer2 from "@/data/layer2_new.json";
import layer3 from "@/data/layer3_new.json";
import layer4 from "@/data/layer4_new.json";
import layer5 from "@/data/layer5_new.json";
import { getNewProjectList, getProjectDetail } from "@/api/enterprise";
const wellknown = require("wellknown");
// isIntegrity是否为单独图层

export default {
  props: ["building"],
  components: {
    linkagecell,
  },
  data() {
    return {
      isShow: false,
      activeNames: [],
      legEndList: [],
      radioChecked1: [],
      OneArrCheckList: [],
      mapEvents: ["click", "touchend"],
      checkList: [
        {
          title: "企业筛选",
          open: false,
          children: layer1.data,
        },
        {
          title: "产业空间改造",
          open: false,
          children: layer2.data,
        },
        // {
        //   title: "产业规划",
        //   open: false,
        //   children: layer3.data,
        // },
        {
          title: "城市规划",
          open: false,
          children: layer4.data,
        },
        // {
        //     title: '地理资源分布',
        //     open: false,
        //     children: layer6.data
        // },
        {
          title: "我的项目",
          newProjectNum: process.client
            ? window.localStorage.getItem("newProjectNum")
            : 0,
          open: false,
          children: [],
        },
        {
          title: "其他图层",
          open: false,
          children: layer5.data,
        },
      ],
    };
  },
  mounted() {},
  methods: {
    // 获取选中
    async getCheckedVals() {
      await this.showPop(false);
      await this.handleCheckedChange1(this.radioChecked1, true);
    },
    async getProjectList() {
      const res = await getNewProjectList({});
      let arr = res.data.map((item) => {
        item.title = item.group_name;
        item.open = false;
        item.children = item.projects.map((data) => {
          return {
            label: data.project_name,
            checkVal: 20,
            optVal: 100,
            isChcek: false,
            isImage: false,
            isCustom: true,
            project_id: `${data.project_id}`,
            keyName: `custom_project_${data.project_id}`,
            key: [
              `custom_project_${data.project_id}`,
              `custom_project_${data.project_id}_line`,
            ],
          };
        });
        return item;
      });
      this.$set(this.checkList[this.checkList.length - 2], "children", arr);
    },
    hidePop() {
      this.isShow = false;
    },
    togglePop() {
      this.isShow = !this.isShow;
    },
    async showPop(isShow = true) {
      await this.getProjectList();
      this.OneArrCheckList = this.flattenArray(this.checkList);
      if (isShow) {
        this.isShow = true;
      }
    },
    closePanel() {
      $("#mapboxglTranslate").click();
    },
    sameCheck(checkeds) {
      this.radioChecked1 = checkeds;
      this.handleCheckedChange1(checkeds, false);
    },
    flattenArray(arr) {
      let result = [];
      arr.forEach((item) => {
        result.push(item);
        if (item.children && item.children.length > 0) {
          result = result.concat(this.flattenArray(item.children));
        }
      });
      return result;
    },
    changeChildrenGroup(index, k) {
      if (this.checkList[index]["children"][k].open) {
        this.$set(this.checkList[index]["children"][k], "open", false);
      } else {
        this.$set(this.checkList[index]["children"][k], "open", true);
      }
    },
    changeGroup(i) {
      if (this.checkList[i].newProjectNum > 0) {
        window.localStorage.setItem("newProjectNum", 0);
        this.$set(this.checkList[i], "newProjectNum", 0);
      }
      if (this.checkList[i].open) {
        this.$set(this.checkList[i], "open", false);
      } else {
        this.$set(this.checkList[i], "open", true);
      }
    },

    concactUs() {
      this.$emit("handleConcactUs");
    },
    doSelect1(selectValue) {
      this.$emit("doSelect1", selectValue);
    },
    doSelect2(selectValue) {
      this.$emit("doSelect2", selectValue);
    },
    doSelect3(selectValue) {
      this.$emit("doSelect3", selectValue);
    },

    getChanYeValByTopic1(selectValue) {
      this.$emit("doChanyeSelect1", selectValue);
    },
    getChanYeValByTopic2(selectValue) {
      this.$emit("doChanyeSelect2", selectValue);
    },

    getQiYeByTopic1(selectValue) {
      this.$emit("doQiYeSelect1", selectValue);
    },
    getQiYeByTopic2(selectValue) {
      this.$emit("doQiYeSelect2", selectValue);
    },

    setCheckVal1(e, key, i) {
      this.checkList1[i].checkVal = e;
      if (key instanceof Array) {
        key = key[1];
      }
      this.building.setLayerZoomRange(key, 10, e);
    },
    setCheckVal(e, key, i) {
      this.checkList[i].checkVal = e;
      if (key instanceof Array) {
        key = key[1];
      }
      this.building.setLayerZoomRange(key, 10, e);
      // this.building.setLayoutProperty(
      //     key,
      //     "maxzoom",
      //     e
      // )
    },
    findLastIndex(array, predicate) {
      let index = array.slice().reverse().findIndex(predicate);
      return index >= 0 ? array.length - 1 - index : index;
    },
    arrayDimension(arr) {
      if (!Array.isArray(arr)) {
        return 0; // 不是数组，返回0
      }

      // 如果是数组，检查其元素
      let maxDim = 0;
      for (let i = 0; i < arr.length; i++) {
        maxDim = Math.max(maxDim, this.arrayDimension(arr[i]));
      }
      return 1 + maxDim; // 返回当前维度+子数组的最大维度
    },
    parseMul(wktString) {
      // 将多边形变成单边形
      const geoJson = wellknown.parse(wktString);
      // 创建一个空的特性数组
      if (this.arrayDimension(geoJson.coordinates) == 3) {
        return {
          geometry: {
            type: "Polygon",
            coordinates: geoJson.coordinates,
          },
        };
      }
      return {
        geometry: {
          type: "MultiPolygon",
          coordinates: geoJson.coordinates,
        },
      };
    },
    noText(key, unlabel) {
      debugger;
      // 切换无文字图层
      if (this.building.getLayer(key)) {
        let visib = this.building.getLayoutProperty(key, "visibility");
        if (visib == "visible") {
          // 让法定图则消失
          // 让无文案得法定图则显示
          this.building.setLayoutProperty(key, "visibility", "none");

          this.building.setLayoutProperty(unlabel, "visibility", "visible");
        } else {
          this.building.setLayoutProperty(key, "visibility", "visible");
          this.building.setLayoutProperty(unlabel, "visibility", "visible");
        }
      }
    },
    async handleCheckedChange1(e, changeLayer = true) {
      console.log("handleCheckedChange1", e, changeLayer);
      let checkList = e.map((item) => {
        let it = this.OneArrCheckList.find((data) => data.keyName == item);
        if (it) {
          it.isChcek = true;
        }
        return it;
      });

      let myProjects = checkList.filter((item) => {
        if (item) {
          return item.isCustom == true;
        }
        return false;
      });
      // 全部隐藏
      this.building.getStyle().layers.forEach((layer) => {
        if (layer.id.startsWith("custom_project_")) {
          this.building.setLayoutProperty(layer.id, "visibility", "none");
        }
      });

      // 找到所有带fdtz_unlabel的图层
      this.building.getStyle().layers.forEach((layer) => {
        if (layer.id.endsWith("_unlabel")) {
          let lay = layer.id.replace("_unlabel", "");

          // this.building.setLayoutProperty(layer.id, 'visibility', 'visible');
          const ite = checkList.findIndex((it) => it.keyName == lay);
          if (ite == -1) {
            this.building.setLayoutProperty(layer.id, "visibility", "none");
          }
        }
      });

      if (myProjects.length > 0) {
        for (let i = 0; i < myProjects.length; i++) {
          if (!this.building.getSource(`${myProjects[i].keyName}_0`)) {
            const res = await getProjectDetail({
              project_id: myProjects[i].project_id,
            });
            const geoJson = wellknown.parse(res.data.project_data);
            let coords = [];
            if (this.arrayDimension(geoJson.coordinates) == 3) {
              coords.push(geoJson.coordinates);
            } else {
              coords = geoJson.coordinates;
            }

            coords.forEach((item, k) => {
              this.building.addSource(`${myProjects[i].keyName}_${k}`, {
                type: "geojson",
                generateId: true,
                data: {
                  type: "Feature",
                  properties: res.data.style,
                  geometry: {
                    type: "Polygon",
                    coordinates: item,
                  },
                },
              });

              this.building.addLayer({
                id: `${myProjects[i].keyName}_${k}`,
                type: "fill",
                source: `${myProjects[i].keyName}_${k}`,
                layout: {
                  visibility: "none",
                  // "zindex": 1
                },
                paint: {
                  "fill-color": [
                    "case",
                    ["boolean", ["feature-state", "hover"], false],
                    "#808aff",
                    res.data.style.shapeFillColor,
                  ],
                  "fill-outline-color": res.data.style.shapeStrokeColor,
                  "fill-opacity": res.data.style.shareOpacity,
                },
              });

              this.building.addLayer({
                id: `${myProjects[i].keyName}_line_${k}`,
                type: "line",
                source: `${myProjects[i].keyName}_${k}`,
                layout: {
                  visibility: "none",
                  "line-cap": "round",
                  "line-join": "round",
                },
                paint: {
                  "line-dasharray": [
                    "case",
                    ["==", ["get", "lineBorderStyle"], 0],
                    ["literal", [1]], // 实线
                    ["==", ["get", "lineBorderStyle"], 1],
                    ["literal", [2, 1]], // 虚线
                    ["==", ["get", "lineBorderStyle"], 2],
                    ["literal", [0.2, 2]], // 点线
                    ["literal", [1]], // 默认情况，实线
                  ],
                  "line-color": res.data.style.shapeStrokeColor,
                  "line-opacity": res.data.style.lineOpacity,
                  "line-width": Number(res.data.style.shapeBorderWidth) || 1,
                },
              });
              this.mapEvents.forEach((eve) => {
                this.building.on(eve, `${myProjects[i].keyName}_${k}`, (e) => {
                  let features = this.building.queryRenderedFeatures(e.point);
                  if (features.length > 0) {
                    let parkInfo = {};
                    parkInfo.layerName = `我的项目图层-${item.label}`;
                    parkInfo.points = features[0].geometry.coordinates[0];
                    this.$emit("disCovered", parkInfo);
                  }
                });
              });

              this.building.on(
                "mousemove",
                `${myProjects[i].keyName}_${k}`,
                (e) => {
                  let features = this.building.queryRenderedFeatures(e.point);
                  this.building.getCanvas().style.cursor = "pointer";
                  if (this[`project_houer_${item.keyName}_${k}`]) {
                    this.building.removeFeatureState(
                      {
                        source: `${myProjects[i].keyName}_${k}`,
                        id: this[`project_houer_${item.keyName}_${k}`],
                      },
                      "hover"
                    );
                    this[`project_houer_${item.keyName}_${k}`] = null;
                  }
                  this.building.setFeatureState(
                    {
                      source: `${myProjects[i].keyName}_${k}`,
                      id: features[0].id,
                    },
                    { hover: true }
                  );
                  this[`project_houer_${item.keyName}_${k}`] = features[0].id;
                }
              );

              this.building.on(
                "mouseleave",
                `${myProjects[i].keyName}_${k}`,
                (e) => {
                  this.building.getCanvas().style.cursor = "";
                  if (this[`project_houer_${item.keyName}_${k}`] != null) {
                    try {
                      this.building.removeFeatureState(
                        {
                          source: `${myProjects[i].keyName}_${k}`,
                          id: this[`project_houer_${item.keyName}_${k}`],
                        },
                        "hover"
                      );
                      this[`project_houer_${item.keyName}_${k}`] = null;
                    } catch (error) {}
                  }
                }
              );
            });
          }
        }
      }

      let lastIndex = this.findLastIndex(
        checkList,
        (item) => item && item.isIntegrity
      );
      if (lastIndex > -1) {
        // 选中500强
        this.$emit("emitEnterPriseTopChange", {
          keyName: checkList[lastIndex].keyName,
          layerName: checkList[lastIndex].label,
        });
      }
      this.$emit("changeLayers", {
        checkedVals: checkList.filter(
          (value) => value !== null && value !== undefined
        ),
        changeLayer,
      });
    },

    // 选中一个图层 selected layer
    handleCheckedChange(layer) {
      // 勾选  this.radioChecked1
      this.radioChecked1.push(layer);
    },
  },
};
